import { render, staticRenderFns } from "./TogglesSection.vue?vue&type=template&id=2a16f40b&scoped=true"
import script from "./TogglesSection.vue?vue&type=script&lang=js"
export * from "./TogglesSection.vue?vue&type=script&lang=js"
import style0 from "./TogglesSection.vue?vue&type=style&index=0&id=2a16f40b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16f40b",
  null
  
)

export default component.exports